<template>
  <div id="app" class="shell" v-if="ready">
    <header-component params="route: route" v-if="!inFrame"></header-component>
    <div class="content-area" v-bind:class="{ embedded: inFrame }">
      <router-view></router-view>
    </div>
    <footer-component v-if="!inFrame"></footer-component>
    <div class="spinner-container" v-if="spinnerShown">
      <spinner :active="true"></spinner>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Spinner from 'vue-loading-overlay';
  import Header from './header';
  import Footer from './footer';
  import Title from './title';

  Vue.component('header-component', Header);
  Vue.component('footer-component', Footer);
  Vue.component('spinner', Spinner);
  Vue.component('vue-title', Title);

  export default {
    data: () => ({
      ready: false,
    }),

    computed: {
      inFrame() {
        let inFrame;
        try {
          inFrame = window.self !== window.top;
        } catch (e) {
          inFrame = true;
        };

        return inFrame && this.$displayMode === "popup";
      },
      spinnerShown () {
        return this.$store.state.pendingRequests > 0;
      }
    },

    async created () {
      await this.$root.setLocale(this.$i18n.fallbackLocale);
      this.ready = true;
    }
  };
</script>

<style>
  .spinner-container {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>